import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import "./StoreBanner.scss";
import { isEmpty } from "../../../../custom_utilities/custom_useful_functions";
import images from "../../../../utilities/images/images";
import Navbar from "../../Navbar/Navbar";
import Select from "react-select";

export const StoreBanner = (props) => {
  const { setIsLoginOpen, isLoginOpen } = props;
  const [isLoading, setIsLoading] = useState(true);
  const { target_id, class_id } = useParams();
  const [data, setData] = useState(null);
  const [searchData, setSearchData] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState({
    class: null,
    target: null,
    course: null,
  });
  console.log("courseId:", class_id);
  const history = useHistory();

  useEffect(() => {
    const fetchSearchData = async () => {
      try {
        const response = await axios.get(
          "https://learning.motion.ac.in/motioneducation/api/v1/courses_and_classes",
          {
            headers: {
              Authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoxMTc3MDYsImV4cGlyZXNfYXQiOiIyMDIzLTA5LTI5IDEyOjUyOjM4In0.c68zFGRBLzs4Jw6J8ZhdyMgY2qxQZMKUVU_2aFzeaA8`,
            },
          }
        );
        setSearchData(response.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchSearchData();
  }, []);

  const fetchPackageData = async (targetId, classId) => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `https://learning.motion.ac.in/motioneducation/api/user/package_list_web?target_id=${targetId}&class_id=${classId}`
      );
      setData(response.data.data);
    } catch (error) {
      console.error("Error fetching package data:", error);
      setData(null);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const selectedTargetId = selectedOptions.target?.value || target_id;
    const selectedClassId = selectedOptions.class?.value || class_id;

    if (selectedTargetId && selectedClassId) {
      fetchPackageData(selectedTargetId, selectedClassId);
    }
  }, [selectedOptions.target, selectedOptions.class, target_id, class_id]);

  const targetOptions =
    searchData?.target?.map((t) => ({
      value: t.target_id,
      label: t.target,
    })) || [];

  const classOptions =
    (selectedOptions.target?.value &&
      searchData?.target
        ?.find((t) => t.target_id === selectedOptions.target.value)
        ?.classes?.map((cls) => ({
          value: cls.class_id,
          label: cls.class,
        }))) ||
    [];

  const courseOptions =
    (selectedOptions.class?.value &&
      searchData?.target
        ?.find((t) => t.target_id === selectedOptions.target?.value)
        ?.classes?.find((cls) => cls.class_id === selectedOptions.class?.value)
        ?.course?.map((crs) => ({
          value: crs.course_id,
          label: crs.course,
        }))) ||
    [];

  const handlePurchaseInitiation = (packageId) => {
    localStorage.setItem("packageId", packageId);
    setIsLoginOpen(true);
  };

  const handleViewDetailsClick = (packageId) => {
    history.push(`/packages-overview/${packageId}`);
  };

  useEffect(() => {
    if (!searchData) return;

    const defaultTarget = searchData?.target?.find(
      (t) => t.target_id === parseInt(target_id)
    );

    const defaultClass = defaultTarget?.classes?.find(
      (cls) => cls.class_id === parseInt(class_id)
    );

    // if (!defaultTarget || !defaultClass) {
    //   setData(null);
    // }

    setSelectedOptions({
      target: defaultTarget
        ? { value: defaultTarget.target_id, label: defaultTarget.target }
        : null,
      class: defaultClass
        ? { value: defaultClass.class_id, label: defaultClass.class }
        : null,
      course: null,
    });
  }, [searchData, target_id, class_id]);

  const filteredPackages = !isEmpty(data?.package)
    ? data?.package.filter((packageItem) =>
        selectedOptions.course
          ? packageItem.course_id === selectedOptions.course.value
          : true
      )
    : [];
  console.log("Chiranjeeb:", filteredPackages);

  const handleTargetChange = async (selected) => {
    const selectedTargetData = searchData?.target?.find(
      (t) => t.target_id === selected.value
    );

    const defaultClass = selectedTargetData?.classes?.[0];

    const defaultClassOption = defaultClass
      ? { value: defaultClass.class_id, label: defaultClass.class }
      : null;

    const updatedOptions = {
      target: selected,
      class: defaultClassOption,
      course: null,
    };

    setSelectedOptions(updatedOptions);

    if (defaultClassOption) {
      history.push(`/login-store/${selected.value}/${defaultClass.class_id}`);
      await fetchPackageData(selected.value, defaultClass.class_id); // 👈 force fetch
    } else {
      setData(null); // No class, clear data
    }
  };

  const handleClassChange = (selected) => {
    setSelectedOptions((prev) => ({
      ...prev,
      class: selected,
      course: null,
    }));

    if (selectedOptions.target?.value) {
      history.push(
        `/login-store/${selectedOptions.target.value}/${selected.value}`
      );
    }
  };

  return (
    <div style={{ overflow: "hidden" }}>
      <Navbar setIsLoginOpen={setIsLoginOpen} isLoginOpen={isLoginOpen} />

      <div className="store-details-inner-wrapper">
        <div className="content-and-btn-wrapper">
          <div className="content">
            <div className="heading">
              {data?.target_details?.target} Courses
            </div>
            <div className="sub-heading">
              {data?.class_name?.class} Class {data?.target_details?.target} all
              courses{" "}
            </div>
          </div>
          <div className="target-icon">
            <img src={data?.target_details?.target_icon} alt="target_icon" />
          </div>
        </div>
      </div>

      <div className="parent-dropdown-container">
        <div className="dropdown-container">
          <span className="label">Select</span>

          <Select
            className="dropdown"
            options={targetOptions}
            placeholder="Target"
            value={selectedOptions.target}
            onChange={handleTargetChange}
          />

          <Select
            className="dropdown"
            options={classOptions}
            placeholder="Class"
            value={selectedOptions.class}
            onChange={handleClassChange}
          />

          <Select
            className="dropdown"
            options={courseOptions}
            placeholder="Course"
            value={selectedOptions.course}
            onChange={(selected) =>
              setSelectedOptions((prev) => ({
                ...prev,
                course: selected,
              }))
            }
          />
        </div>
      </div>

      <div className="landing-page-package_offering_component_inner_wrapper">
        {isLoading ? (
          <div>Loading packages...</div>
        ) : filteredPackages.length > 0 ? (
          filteredPackages.map((element) => {
            return (
              <div className="package_outer" key={element.package_id}>
                <div className="package_name_banner">
                  <img src={element.icon} alt="package banner" />
                  <p
                    style={{
                      backgroundColor: element.tag_background,
                      color: element.tag_textcolor,
                    }}
                  >
                    {element.thumbnail_tag}
                  </p>
                </div>
                <p className="package_description">{element.description}</p>
                <div className="package_flex d-flex justify-content-between">
                  <div className="duration_div">
                    <div className="d-flex mb-2">
                      <img src={images.user_activity_calendar} alt="calender" />
                      <p>{element.duration}</p>
                    </div>
                    {element.course_benefits_count !== 0 && (
                      <div className="d-flex">
                        <img src={images.new_store_tick} alt="tick" />
                        <p>{element.course_benefits_count}+ benefits</p>
                      </div>
                    )}
                  </div>
                  {!(
                    parseFloat(element.amount) -
                      parseFloat(element.discount) ===
                    parseFloat(element.amount)
                  ) && (
                    <div className="discount_div d-flex align-items-center">
                      <img src={images.store_offer} alt="offer" />
                      <p>
                        <span>
                          {Math.round(
                            (parseFloat(element.discount) /
                              parseFloat(element.amount)) *
                              100
                          )}
                          %
                        </span>{" "}
                        Off
                      </p>
                    </div>
                  )}
                  <div className="price_div">
                    <p className="final_amount">
                      ₹
                      {parseFloat(element.amount) -
                        parseFloat(element.discount)}
                    </p>
                    {!(
                      parseFloat(element.amount) -
                        parseFloat(element.discount) ===
                      parseFloat(element.amount)
                    ) && (
                      <p className="initial_amount">
                        ₹
                        <span className="text-decoration-line-through">
                          {parseFloat(element.amount)}
                        </span>
                      </p>
                    )}
                  </div>
                </div>
                <div className="package_button_div">
                  <button
                    className="details"
                    onClick={() => handleViewDetailsClick(element.package_id)}
                  >
                    View Details
                  </button>
                  {!element.is_subscribe && (
                    <button
                      onClick={() =>
                        handlePurchaseInitiation(element.package_id)
                      }
                      className="buy"
                    >
                      Buy Now
                    </button>
                  )}
                </div>
              </div>
            );
          })
        ) : (
          <div className="no-course-message">No Courses available</div>
        )}
      </div>
    </div>
  );
};
